import React from "react";
import { useMutation } from "@apollo/client";
import { gql } from "@apollo/client";
import { Form } from "react-final-form";
import { Dialog } from "@syos-music/common";

import { Alert, Button, Grid, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";

const MUTATION = gql`
  mutation ($orderStateId: ID!) {
    DeleteOrderState(orderStateId: $orderStateId) {
      orderState {
        id
        deleted
      }
    }
  }
`;

function DeleteOrderState({ orderState, children }) {
  const [isOpen, setIsOpen] = React.useState(false);

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  const [deleteOrderState] = useMutation(MUTATION);

  return (
    <>
      {children({ isOpen, open, close })}

      <Dialog open={isOpen} onClose={close}>
        <Form
          onSubmit={() =>
            deleteOrderState({
              variables: { orderStateId: orderState.id },
            })
              .then(close)
              .catch(() => true)
          }
          keepDirtyOnReinitialize
        >
          {({ handleSubmit, submitting }) => (
            <form onSubmit={handleSubmit} noValidate autoComplete="off">
              <Dialog.Title color="primary">
                Supprimer un êtat de commande
              </Dialog.Title>

              <Dialog.Content>
                <Grid container>
                  <Grid item xs={12}>
                    <Alert severity="warning">
                      <Typography color="inherit">
                        Voulez-vous vraiment supprimer l’êtat de commande{" "}
                        <code>{orderState.name}</code> ?
                      </Typography>
                    </Alert>
                  </Grid>
                </Grid>
              </Dialog.Content>

              <Dialog.Actions>
                <Button variant="text" onClick={close}>
                  Annuler
                </Button>

                <LoadingButton type="submit" loading={submitting}>
                  Supprimer
                </LoadingButton>
              </Dialog.Actions>
            </form>
          )}
        </Form>
      </Dialog>
    </>
  );
}

DeleteOrderState.fragments = {
  orderState: gql`
    fragment Admin_DeleteOrderState_OrderState on OrderState {
      id
      label
    }
  `,
};

export default DeleteOrderState;
